<template>
  <div class="flex flex-col gap-2 border-b border-gray-800">
    <div class="flex items-center justify-between gap-3 px-2">
      <h4 class="inline-flex items-center gap-2 text-base font-semibold">
        <i class="pi pi-user text-sm"></i>
        Spaces
      </h4>
      <i class="pi pi-chevron-down text-xs"></i>
    </div>
    <ul class="ml-2 flex flex-col gap-2 text-base font-medium">
      <li
        v-for="space in spaceStore.spaces"
        :key="space.id"
        class="hover:bg-primary group flex items-center gap-2 truncate rounded-md p-2 font-medium text-gray-200 transition-all duration-100"
        :title="space.name"
        :class="{
          'bg-primary': space.code === spaceStore.currentSpace,
        }"
        @click="spaceStore.currentSpace = space.code">
        <div class="flex items-center justify-center rounded-md p-1 text-xs font-semibold">
          <DAvatar :label="space.name.charAt(0)" class="h-5! w-5! uppercase" />
        </div>
        <span class="truncate">{{ space.name }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { useSpaceStore } from '@/stores/api/space';
import { onMounted } from 'vue';

const spaceStore = useSpaceStore();

onMounted(async () => {
  await spaceStore.fetch();
});
</script>
